import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-通关 416",
  "use": "icon-通关 416-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-通关 416\"><path d=\"M746.666667 149.333333a64 64 0 0 1 64 64v597.333334a64 64 0 0 1-64 64H277.333333a64 64 0 0 1-64-64V213.333333a64 64 0 0 1 64-64h469.333334z m0 64H277.333333v597.333334h469.333334V213.333333z m-201.728 170.666667l107.349333 126.293333a33.024 33.024 0 0 1-25.173333 54.421334H373.333333v-64h186.816l-63.978666-75.264L544.938667 384z\" p-id=\"26591\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol